import apiClient from "./apiClient";

export const addTestData = async () => {
  const response = await apiClient.post("/bills/test-data");
  return response.data;
};

export const resolveBillManually = async (billId: string, input: {
  action: "IGNORE" | "VALIDATE_MANUALLY";
  userComment?: string | null;
}) => {
  return await apiClient.patch(`/bills/${billId}/manual-resolution`, input);
};

export type OrphanBillCandidate = {
  id: string;
  providerId: string;
  accountName: string | null;
  soldItemsDescription: string | null;
  amountDue: number;
  startPeriod: string;
  endPeriod: string;
};

export const searchOrphanBills = async (q: string) => {
  return await apiClient.get<OrphanBillCandidate[]>("bills/orphans", {
    params: { q },
  });
};
